<mat-toolbar>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="end center" fxFlex>
    <div fxLayout="row" fxLayoutAlign="start center">
      <a mat-button routerLink="/documentation/getting-started/introduction">GameBoard Tech</a>
      <a mat-button routerLink="">{{ date | date:'y'}}</a>
    </div>
  </div>
</mat-toolbar>
